/**
 * Formats a publish date for SSR/ISR HTML.
 *
 * Relative labels ("Today" / "Yesterday") are intentionally unused: they
 * change homepage HTML at midnight and force a billed ISR write even when
 * CMS content is unchanged. `showRelative` is accepted for call-site
 * compatibility and ignored.
 */
export function formatRelativeDate(
  date: string | Date,
  _options?: { showRelative?: boolean }
): string {
  return formatExactDate(date);
}

/**
 * Formats a date to "December 5, 2025" format
 */
function formatExactDate(date: string | Date): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/**
 * Estimates reading time from HTML article content at 225 words/minute,
 * rounded up to the nearest minute. Returns null for empty/missing content.
 */
export function estimateReadTime(html?: string): string | null {
  if (!html) return null;
  const words = html.replace(/<[^>]+>/g, ' ').trim().split(/\s+/).filter(Boolean).length;
  if (!words) return null;
  return `${Math.max(1, Math.round(words / 225))} min read`;
}
